import { render, staticRenderFns } from "./TechnicalCommitteeEditor.vue?vue&type=template&id=8e22c9e6&scoped=true&"
import script from "./TechnicalCommitteeEditor.vue?vue&type=script&lang=js&"
export * from "./TechnicalCommitteeEditor.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalCommitteeEditor.vue?vue&type=style&index=0&id=8e22c9e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e22c9e6",
  null
  
)

export default component.exports